import VerbamailIcon from "../../../../../../../assets/svg/verbamail-icon";
import { getDateTimeByFormat } from "../../../../../../../redux/slices/dateTimeFormatSlice";
import type { InboxThread } from "../../../utils/types";
interface InboxEmailCardProps {
  thread: InboxThread;
  isSelected?: boolean;
  onClick?: () => void;
}

const InboxEmailCard: React.FC<InboxEmailCardProps> = ({
  thread,
  isSelected = false,
  onClick,
}) => {
  const isUnread = !thread.is_read;

  return (
    <div
      className={`w-full cursor-pointer border-b border-border-gray dark:border-border-gray-dk px-[12px] py-[14px] flex gap-[10px] min-w-0 transition-colors duration-200 ${
        isSelected
          ? "bg-card-highlight lead-card-selected border-l-[3px] border-l-verba-blue dark:border-l-verba-blue-dk"
          : isUnread
            ? "bg-pure-white dark:bg-pure-white-dk hover:bg-hover-effect"
            : "bg-pure-white dark:bg-pure-white-dk hover:bg-hover-effect opacity-60"
      }`}
      onClick={onClick}
    >
      <div className="bg-verba-indigo dark:bg-verba-indigo-dk flex w-fit h-fit rounded-full p-1">
        <VerbamailIcon className="w-4 h-4 text-verba-pearl dark:text-verba-pearl-dk" />
      </div>

      <div className="flex flex-col gap-[4px] min-w-0 flex-1">
        <div className="flex items-center justify-between gap-[8px]">
          <div className="flex items-center gap-[6px] min-w-0 flex-1">
            <p
              className={`text-base truncate min-w-0 ${
                isSelected
                  ? "text-verba-indigo dark:text-verba-indigo-dk font-semibold"
                  : isUnread
                    ? "text-data dark:text-data-dk font-semibold"
                    : "text-data dark:text-data-dk font-medium"
              }`}
            >
              {thread?.from_email}
            </p>
          </div>
          <div className="flex items-center gap-[4px] shrink-0">
            <p className="text-sm font-normal text-gray-placeholder dark:text-gray-placeholder-dk">
              {getDateTimeByFormat(new Date(thread?.latest_message_at))?.date}
            </p>
          </div>
        </div>

        <p
          className={`text-md truncate min-w-0 text-verba-indigo dark:text-verba-indigo-dk ${
            isUnread ? "font-semibold" : "font-medium"
          }`}
        >
          {thread?.subject}
        </p>

        <p className="text-md text-dark-gray dark:text-dark-gray-dk font-normal truncate min-w-0">
          {thread.latest_message_snippet}
        </p>
      </div>
    </div>
  );
};

export default InboxEmailCard;
